"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminMain = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const common_1 = require("../../common");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const account_1 = require("../base/account");
const app_1 = require("../base/app");
const action_1 = require("../menu/action");
const function_1 = require("../menu/function");
const AdminContent_1 = require("./AdminContent");
const AdminMenu_1 = require("./AdminMenu");
const AdminMenuDetail_1 = require("./AdminMenuDetail");
exports.AdminMain = react_1.default.memo(() => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const load = (0, react_redux_1.useSelector)((state) => state['base/app'].isLoad);
    const role = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserRole)(state));
    const isAcademyAdmin = role === 'academy';
    const academyNickname = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserNickname)(state));
    const { depths, menu, props } = (0, react_redux_1.useSelector)((state) => (0, function_1.getMenuData)(state), react_redux_1.shallowEqual);
    (0, react_1.useEffect)(() => {
        if (!load)
            dispatch((0, app_1.appWillLoad)());
        return () => {
            dispatch((0, app_1.appWillUnmount)());
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (isAcademyAdmin && depths !== 'academyStatistics') {
            dispatch((0, action_1.updateMenu)('academyStatistics', { menu: 'academyStatistics', detail: 'list' }));
        }
    }, [isAcademyAdmin]);
    const handlerChangeMenu = (0, react_1.useCallback)((data) => {
        dispatch((0, action_1.updateMenu)(depths, { menu: menu.menu, detail: data.showDepth }, undefined, data.props));
    }, [depths, menu.menu]);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('CHANGE_MENU', handlerChangeMenu);
        return () => {
            APP.eventManager.unsubscribe('CHANGE_MENU', handlerChangeMenu);
        };
    }, [handlerChangeMenu]);
    const handlerPreviousMenu = () => {
        dispatch((0, action_1.goToPrevMenu)());
    };
    const getMenuName = (changeDepth) => {
        switch (changeDepth) {
            case 'backOffice':
                return 'assignment';
            case 'statistics':
                return 'userStatistics';
            case 'academyStatistics':
                return 'academyStatistics';
            default:
                return changeDepth;
        }
    };
    const defaultMenuDepth = isAcademyAdmin ? 'academyStatistics' : 'classManagement';
    return (react_1.default.createElement("div", { className: `admin-container ${isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'}  ` },
        react_1.default.createElement("div", { className: "admin-sidebar" },
            react_1.default.createElement(common_1.Button, { className: "btn-logo", option: {
                    buttonBeforeIcon: {
                        show: true,
                        width: 98,
                        height: 35,
                        name: 'logo_white',
                    },
                }, onClick: () => {
                    dispatch((0, action_1.updateMenu)(defaultMenuDepth, {
                        menu: defaultMenuDepth,
                        detail: 'list',
                    }));
                } }),
            react_1.default.createElement(AdminMenu_1.AdminMenu, { menu: depths, menuDetail: menu.menu, setMenuDetail: changeMenu => dispatch((0, action_1.updateMenu)(depths, { menu: changeMenu, detail: 'list' })) })),
        react_1.default.createElement("div", { className: "admin-content" },
            react_1.default.createElement("div", { className: "admin-menu-detail" },
                isAcademyAdmin
                    ? react_1.default.createElement("p", { className: "admin-academy-name" }, academyNickname)
                    : (react_1.default.createElement(AdminMenuDetail_1.AdminMenuDetail, { menu: depths, setMenu: changeDepth => {
                            const menu = getMenuName(changeDepth);
                            dispatch((0, action_1.updateMenu)(changeDepth, { menu, detail: 'list' }));
                        } })),
                react_1.default.createElement(account_1.MyPageDropDown, { isSidebar: false })),
            react_1.default.createElement(AdminContent_1.AdminContent, { menu: depths, menuDetail: menu.menu, showDepth: menu.detail, props: props, handlerPreviousMenu: handlerPreviousMenu }))));
});
